/* HighDeep shared front-end utilities (esc / ft).
 * Loaded globally via theme.liquid. Do NOT redefine these inside section files —
 * use window.HD.esc() / window.HD.ft() instead. */
window.HD = (function () {
  // HTML-escape untrusted strings before innerHTML injection
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // fetch with timeout (default 10s) — prevents infinite loading when bridge hangs
  /* 2026-10-13 (A2)：**统一校验响应状态**。原实现只做超时，服务端 4xx/5xx 只要回了 JSON
     就被调用方当成成功 ⇒ 这是历史上反复出现「假成功」（按钮变「已保存」其实没保存）的结构性根源。
     现在非 2xx 一律 reject（err.status 带上状态码），调用方的 .catch / 状态码检查才真正起作用。
     逃生舱：opts.allowNotOk === true 时保持旧行为（仅给「非 2xx 也有业务含义」的调用点用）。 */
  function ft(url, opts, ms) {
    ms = ms || 10000;
    opts = Object.assign({ credentials: 'include' }, opts || {});
    var _p;
    if (typeof AbortSignal !== 'undefined' && AbortSignal.timeout) {
      _p = fetch(url, Object.assign({}, opts || {}, { signal: AbortSignal.timeout(ms) }));
    } else {
      var ctrl = new AbortController(), to = setTimeout(function () { ctrl.abort(); }, ms);
      _p = fetch(url, Object.assign({}, opts || {}, { signal: ctrl.signal }))
        .then(function (r) { clearTimeout(to); return r; }, function (e) { clearTimeout(to); throw e; });
    }
    return _p.then(function (r) {
      if (r.ok || (opts && opts.allowNotOk)) return r;
      var err = new Error('HTTP ' + r.status + ' — ' + url);
      err.status = r.status;
      err.response = r;
      throw err;
    });
  }
  return { esc: esc, ft: ft };
})();

/* ---- 购物车反馈原语（唯一实现）------------------------------------------------
   顶栏数字角标 = 唯一真相。产品页加购、购物车改数量/删除、以及将来任何写入点
   都必须走这里；禁止在 section 里再写第二份（同一维度两份实现 = 必然不同步）。

   背景（为什么必须抽出来）：
   · theme.liquid 服务端原本只渲染 .cart-dot（8px 圆点、无数字，item_count=0 时不存在）；
   · theme.css 里 .cart-count 的数字角标样式早就写好了，但**全主题从未被使用**；
   · cart.liquid 的同步代码查的是 `.cart-count-bubble, [class*="cart-count"]`
     ⇒ 匹配不到 .cart-dot ⇒ 改数量/删除后顶栏角标静默不更新。
   本原语把这三处收敛到一条链上。 */
window.HD.cartUI = (function () {
  function link() {
    return document.querySelector('.site-nav .cart-link') || document.querySelector('.cart-link');
  }
  /* 查/建数字角标；顺带隐藏服务端的 8px 圆点，避免两个指示器叠在一起 */
  function badge() {
    var a = link();
    if (!a) { return null; }
    var el = a.querySelector('.cart-count');
    if (!el) {
      el = document.createElement('span');
      el.className = 'cart-count';
      el.setAttribute('aria-hidden', 'true');
      a.appendChild(el);
    }
    var dot = a.querySelector('.cart-dot');
    if (dot) { dot.style.display = 'none'; }
    return el;
  }
  function setCount(n) {
    if (typeof n !== 'number' || !isFinite(n)) { return; }
    var el = badge();
    if (!el) { return; }
    el.textContent = n > 0 ? String(n) : '';
  }
  /* 角标弹一下（0.2s，只动 transform）。空角标不播。 */
  function pop() {
    var el = badge();
    if (!el || !el.textContent) { return; }
    el.classList.remove('is-pop');
    void el.offsetWidth; /* 强制重排一次，否则第二次加购不会重播同一动画 */
    el.classList.add('is-pop');
    setTimeout(function () { el.classList.remove('is-pop'); }, 400);
  }
  /* /cart.js 取权威数量；失败返回 null —— 由调用方决定降级，绝不猜数 */
  function fresh() {
    return window.HD.ft('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }, 8000)
      .then(function (r) { if (!r.ok) { throw new Error('HTTP ' + r.status); } return r.json(); })
      .then(function (c) { return (c && typeof c.item_count === 'number') ? c.item_count : null; });
  }
  /* 同步 + 弹一次。网络失败静默：角标维持原值，优于显示一个错数字。 */
  function sync() {
    return fresh().then(function (n) {
      if (n !== null) { setCount(n); pop(); }
      return n;
    }).catch(function () { return null; });
  }
  return { badge: badge, setCount: setCount, pop: pop, fresh: fresh, sync: sync };
})();

/* ---- 加购飞入购物车（#8，唯一实现）----------------------------------------------
   从加购按钮飞一个"商品图缩略"到顶栏购物车图标；落地后由调用方同步角标。
   返回 Promise<boolean>：true = 真的飞了；false = 环境不支持，调用方应走原逻辑。
   🔴 只动 transform / opacity；用**两层嵌套**造抛物线（单层 transform 只能走直线）。
   🔴 触屏、prefers-reduced-motion、?pfm=off 三种情况都直接 resolve(false) 不飞
      （手机上飞行既看不清又费电）。
   🔴 同一维度只留一份实现（本项目铁律）—— 禁止在 section 里再写一个飞入。 */
window.HD.flyToCart = (function () {
  function cartLink() {
    return document.querySelector('.site-nav .cart-link') || document.querySelector('.cart-link');
  }
  /* 优先拿"正在展示的主图"；取不到就回落到品牌渐变小方块（.pf-fly__dot 的 CSS 默认背景） */
  function pickImg() {
    var cands = ['.pm-fan__card--main img', '.pm-fan img', '.product-main img', 'main img'];
    for (var i = 0; i < cands.length; i++) {
      var im = document.querySelector(cands[i]);
      if (im) { var u = im.currentSrc || im.src; if (u) { return u; } }
    }
    return '';
  }
  return function fly(fromEl) {
    return new Promise(function (resolve) {
      try {
        var mm = window.matchMedia;
        if (mm && mm('(prefers-reduced-motion: reduce)').matches) { resolve(false); return; }
        if (mm && mm('(pointer: coarse)').matches) { resolve(false); return; }
        if (/(?:^|[?&])pfm=off(?:&|$)/.test(String(location.search || ''))) { resolve(false); return; }
        var link = cartLink();
        if (!fromEl || !link || !fromEl.getBoundingClientRect) { resolve(false); return; }

        var a = fromEl.getBoundingClientRect();
        var b = link.getBoundingClientRect();
        /* 起点或终点不可见就不要飞（滚出视口时飞过去会很怪） */
        if (a.width < 1 || b.width < 1 || b.bottom < 0 || b.top > window.innerHeight) { resolve(false); return; }

        var SIZE = 40;
        var sx = a.left + a.width / 2, sy = a.top + a.height / 2;
        var ex = b.left + b.width / 2, ey = b.top + b.height / 2;

        var wrap = document.createElement('div');
        wrap.className = 'pf-fly';
        wrap.style.width = wrap.style.height = SIZE + 'px';
        wrap.style.transform = 'translate3d(' + (sx - SIZE / 2) + 'px,' + (sy - SIZE / 2) + 'px,0)';

        var yv = document.createElement('div');
        yv.className = 'pf-fly__y';
        var dot = document.createElement('div');
        dot.className = 'pf-fly__dot';
        var src = pickImg();
        if (src) {
          dot.style.backgroundImage = 'url("' + src + '")';
          dot.style.backgroundSize = 'cover';
          dot.style.backgroundPosition = 'center';
        }
        yv.appendChild(dot); wrap.appendChild(yv); document.body.appendChild(wrap);

        /* 🔴 必须**下一帧**才写目标值：同一帧写两次不会产生过渡（元素会直接跳过去） */
        requestAnimationFrame(function () {
          wrap.style.transform = 'translate3d(' + (ex - SIZE / 2) + 'px,' + (sy - SIZE / 2) + 'px,0)';
          yv.style.transform = 'translate3d(0,' + (ey - sy) + 'px,0)';
          dot.style.transform = 'scale(.24)';
          dot.style.opacity = '.15';
        });
        setTimeout(function () {
          if (wrap.parentNode) { wrap.parentNode.removeChild(wrap); }
          resolve(true);
        }, 690);
      } catch (e) { resolve(false); }
    });
  };
})();

/* ---- 全站统一 toast（唯一实现）--------------------------------------------------
   替代原生 alert()：alert 是浏览器模态，样式不可控、阻塞页面、还会把「某次操作失败」
   这件小事放大成一次页面级打断 —— 这是全站最容易看出来的「廉价感」。
   调用：window.HD.toast('Add to cart failed.', 'error')      // info | ok | warn | error
   🔴 文案一律英文（海外站）；🔴 禁止在 section 里再写第二份 toast。 */
window.HD.toast = (function () {
  var host = null;
  var TYPES = { info: 1, ok: 1, warn: 1, error: 1 };
  function ensure() {
    if (host && host.parentNode) { return host; }
    host = document.createElement('div');
    host.className = 'pf-toast-host';
    host.setAttribute('role', 'status');
    host.setAttribute('aria-live', 'polite');
    document.body.appendChild(host);
    return host;
  }
  function toast(msg, type, opts) {
    var text = String(msg == null ? '' : msg);
    if (!text) { return null; }
    var t = TYPES[type] ? type : 'info';
    var h = ensure();
    var el = document.createElement('div');
    el.className = 'pf-toast pf-toast--' + t;
    el.textContent = text; /* 用 textContent ⇒ 天然免疫 XSS，不需要 esc() */
    h.appendChild(el);
    /* 同屏最多 3 条：再多就挤掉最早的（防止一串失败糊满整屏） */
    while (h.children.length > 3) { h.removeChild(h.firstChild); }
    var ms = (opts && opts.duration) || (t === 'error' ? 4200 : 2600);
    function kill() {
      if (!el.parentNode) { return; }
      el.classList.add('is-out');
      setTimeout(function () { if (el.parentNode) { el.parentNode.removeChild(el); } }, 240);
    }
    var timer = setTimeout(kill, ms);
    el.addEventListener('click', function () { clearTimeout(timer); kill(); }); /* 点一下立即消掉 */
    return kill;
  }
  return toast;
})();

/* ---- 断网 / 恢复提示（2026-10-06，全站唯一实现）-----------------------------------
   为什么：断网时点击「没反应」是所有静默失败里最伤的一类 —— 用户会以为网站坏了。
   只监听 online/offline，且**只在状态真实变化时**提示（首屏不提示，避免一进站就弹）。 */
(function () {
  var last = (typeof navigator !== 'undefined') ? navigator.onLine : true;
  function notify(online) {
    if (online === last) { return; }
    last = online;
    try {
      if (!window.HD || !HD.toast) { return; }
      HD.toast(online
        ? 'Back online.'
        : 'You\u2019re offline \u2014 check your connection.', online ? 'ok' : 'warn');
    } catch (e) { /* 静默降级：提示失败不影响任何主流程 */ }
  }
  window.addEventListener('online', function () { notify(true); });
  window.addEventListener('offline', function () { notify(false); });
})();

/* ---- 全站统一输入浮层（唯一实现）-------------------------------------------------
   替代原生 prompt()：原生是浏览器模态，iOS 会带上「域名 说：」前缀、样式不可控、
   移动端还会被输入法遮挡 —— 与 alert 同源的廉价感。
   调用：window.HD.prompt({ title:'…', sub:'…', def:'', ok:'Submit', cancel:'Cancel' })
         .then(function(v){ if (v === null) { return; }   // v === null ⇒ 用户取消
                            … })
   🔴 语义与原生 prompt 一一对应：**取消 ⇒ null**，确定 ⇒ 字符串（**可为空串**，
      由调用方自己决定空串算不算有效输入 —— 本站「举报原因」就是可选的）。
   ⚠️ 本注释块内**不能出现内层块注释的起止符号**（块注释不可嵌套 ⇒ 内层结束符会提前结束
      本注释，把后面的示例代码变成真代码 ⇒ node --check 直接报 SyntaxError）。09-30 已踩两次。
   🔴 文案一律英文（海外站）；🔴 禁止在 section 里再写第二份。 */
window.HD.prompt = (function () {
  var cur = null;

  function close(v, resolve) {
    var c = cur; cur = null;
    if (!c) { resolve(v); return; }
    document.removeEventListener('keydown', c.key, true);
    c.wrap.classList.add('pf-prompt--out');
    setTimeout(function () { try { c.wrap.remove(); } catch (e) {} }, 180);
    resolve(v);
  }

  return function (opts) {
    opts = opts || {};
    if (cur) { close(null, cur.resolve); }   /* 同时只允许一个 */
    return new Promise(function (resolve) {
      var wrap = document.createElement('div');
      wrap.className = 'pf-prompt';
      wrap.setAttribute('role', 'dialog');
      wrap.setAttribute('aria-modal', 'true');

      var box = document.createElement('div');
      box.className = 'pf-prompt__box';

      var hd = document.createElement('div');
      hd.className = 'pf-prompt__title';
      hd.textContent = String(opts.title || '');
      box.appendChild(hd);

      if (opts.sub) {
        var sb = document.createElement('div');
        sb.className = 'pf-prompt__sub';
        sb.textContent = String(opts.sub);
        box.appendChild(sb);
      }

      var inp = document.createElement('input');
      inp.type = 'text';
      inp.className = 'pf-prompt__input';
      inp.placeholder = String(opts.placeholder || '');
      inp.value = String(opts.def == null ? '' : opts.def);
      box.appendChild(inp);

      var row = document.createElement('div');
      row.className = 'pf-prompt__row';
      var no = document.createElement('button');
      no.type = 'button';
      no.className = 'pf-prompt__btn pf-prompt__btn--ghost';
      no.textContent = String(opts.cancel || 'Cancel');
      var yes = document.createElement('button');
      yes.type = 'button';
      yes.className = 'pf-prompt__btn pf-prompt__btn--primary';
      yes.textContent = String(opts.ok || 'Submit');
      row.appendChild(no); row.appendChild(yes);
      box.appendChild(row);
      wrap.appendChild(box);

      var key = function (e) {
        if (e.key === 'Escape') { e.preventDefault(); close(null, resolve); }
        else if (e.key === 'Enter') { e.preventDefault(); close(inp.value, resolve); }
      };
      no.addEventListener('click', function () { close(null, resolve); });
      yes.addEventListener('click', function () { close(inp.value, resolve); });
      /* 点遮罩取消。用 mousedown 而非 click：在输入框里拖选文字后松手落在遮罩上的话，
         click 会被误判成"点外部"。 */
      wrap.addEventListener('mousedown', function (e) { if (e.target === wrap) { close(null, resolve); } });
      document.addEventListener('keydown', key, true);

      cur = { wrap: wrap, key: key, resolve: resolve };
      document.body.appendChild(wrap);
      setTimeout(function () { try { inp.focus(); inp.select(); } catch (e) {} }, 30);
    });
  };
})();

/* ---- 全站统一「身份验证」浮层（收藏登录用）---------------------------
   邮箱 + 昵称双字段；点 Continue 调 /designs/whoami 验证：
     · 邮箱+昵称匹配 ⇒ resolve({email,nick,status:'ok'})（验证通过=登录）
     · 新邮箱(no_account) ⇒ resolve({email,nick,status:'new'})（调用方弹注册窗）
     · 邮箱被占(nickname_mismatch) ⇒ 本浮层内显示占用提示 + 6 位码取回，通过后 resolve ok
   取消 / 点遮罩 / Esc ⇒ null。
   文案一律英文；禁止在 section 里再写第二份。 */
window.HD.identityPrompt = (function () {
  var BRIDGE = 'https://bridge.highdeep.net';
  var cur = null;

  function close(v, resolve) {
    var c = cur; cur = null;
    if (!c) { resolve(v); return; }
    document.removeEventListener('keydown', c.key, true);
    c.wrap.classList.add('pf-prompt--out');
    setTimeout(function () { try { c.wrap.remove(); } catch (e) {} }, 180);
    resolve(v);
  }

  function ft(url, opts, ms) {
    if (window.HD && HD.ft) { return HD.ft(url, opts, ms); }
    var ctrl = new AbortController();
    var t = setTimeout(function () { ctrl.abort(); }, ms || 12000);
    return fetch(url, Object.assign({}, opts || {}, { signal: ctrl.signal })).finally(function () { clearTimeout(t); });
  }

  return function (opts) {
    opts = opts || {};
    if (cur) { close(null, cur.resolve); }
    return new Promise(function (resolve) {
      var wrap = document.createElement('div');
      wrap.className = 'pf-prompt';
      wrap.setAttribute('role', 'dialog');
      wrap.setAttribute('aria-modal', 'true');

      var box = document.createElement('div');
      box.className = 'pf-prompt__box';

      var hd = document.createElement('div');
      hd.className = 'pf-prompt__title';
      hd.textContent = String(opts.title || '');
      box.appendChild(hd);

      if (opts.sub) {
        var sb = document.createElement('div');
        sb.className = 'pf-prompt__sub';
        sb.textContent = String(opts.sub);
        box.appendChild(sb);
      }

      var emailInp = document.createElement('input');
      emailInp.type = 'email';
      emailInp.className = 'pf-prompt__input';
      emailInp.maxLength = 120;
      emailInp.placeholder = String(opts.emailPlaceholder || 'you@example.com');
      emailInp.autocomplete = 'email';
      box.appendChild(emailInp);

      var nameInp = document.createElement('input');
      nameInp.type = 'text';
      nameInp.className = 'pf-prompt__input';
      nameInp.maxLength = 40;
      nameInp.placeholder = String(opts.namePlaceholder || 'Your name / nickname');
      nameInp.autocomplete = 'nickname';
      box.appendChild(nameInp);

      var errEl = document.createElement('div');
      errEl.style.cssText = 'display:none;font-size:.78rem;color:#DC2626;margin-top:8px;line-height:1.4';
      box.appendChild(errEl);

      /* 占用取回区（邮箱已被别的昵称注册） */
      var occ = document.createElement('div');
      occ.style.cssText = 'display:none;margin-top:12px;padding:12px 13px;border:1px solid #FCD34D;background:#FFFBEB;border-radius:10px';
      var occTitle = document.createElement('div');
      occTitle.style.cssText = 'font-size:.84rem;font-weight:700;color:#92400E;line-height:1.4';
      occTitle.textContent = 'This email is already linked to a different designer name.';
      occ.appendChild(occTitle);
      var occSub = document.createElement('div');
      occSub.style.cssText = 'font-size:.78rem;color:#B45309;margin-top:5px;line-height:1.5';
      occSub.textContent = 'If this email belongs to you, verify it \u2014 we\u2019ll email you a 6-digit code and give this email back to you. If it is not yours, use another email, or contact us and we\u2019ll sort it out.';
      occ.appendChild(occSub);
      var occAct = document.createElement('div');
      occAct.style.cssText = 'display:flex;align-items:center;gap:12px;margin-top:10px;flex-wrap:wrap';
      var occVerify = document.createElement('button');
      occVerify.type = 'button';
      occVerify.style.cssText = 'border:none;border-radius:10px;background:#D97706;color:#fff;font-weight:600;font-size:.82rem;padding:8px 15px;cursor:pointer';
      occVerify.textContent = 'Verify this email';
      occAct.appendChild(occVerify);
      var occContact = document.createElement('a');
      occContact.href = 'mailto:service@highdeep.net?subject=Email%20already%20in%20use%20on%20HighDeep';
      occContact.style.cssText = 'font-size:.78rem;font-weight:600;color:#92400E;text-decoration:underline;word-break:break-all';
      occContact.textContent = 'Contact us \u2014 service@highdeep.net';
      occAct.appendChild(occContact);
      occ.appendChild(occAct);
      var occCode = document.createElement('div');
      occCode.style.cssText = 'display:none;gap:8px;align-items:center;margin-top:10px';
      var occCodeInp = document.createElement('input');
      occCodeInp.type = 'text';
      occCodeInp.inputMode = 'numeric';
      occCodeInp.maxLength = 6;
      occCodeInp.placeholder = '6-digit code';
      occCodeInp.style.cssText = 'flex:1 1 auto;min-width:110px;box-sizing:border-box;border:1.5px solid #FCD34D;border-radius:10px;padding:9px 11px;font-size:.95rem;font-weight:700;letter-spacing:.18em;text-align:center;background:#fff;color:#1a1a2e';
      occCode.appendChild(occCodeInp);
      var occCodeOk = document.createElement('button');
      occCodeOk.type = 'button';
      occCodeOk.style.cssText = 'border:none;border-radius:10px;background:#7C3AED;color:#fff;font-weight:600;font-size:.82rem;padding:9px 15px;cursor:pointer;white-space:nowrap';
      occCodeOk.textContent = 'Confirm';
      occCode.appendChild(occCodeOk);
      occ.appendChild(occCode);
      var occMsg = document.createElement('div');
      occMsg.style.cssText = 'display:none;font-size:.76rem;color:#6B7280;margin-top:7px;line-height:1.45';
      occ.appendChild(occMsg);
      box.appendChild(occ);

      var row = document.createElement('div');
      row.className = 'pf-prompt__row';
      var no = document.createElement('button');
      no.type = 'button';
      no.className = 'pf-prompt__btn pf-prompt__btn--ghost';
      no.textContent = String(opts.cancel || 'Cancel');
      var yes = document.createElement('button');
      yes.type = 'button';
      yes.className = 'pf-prompt__btn pf-prompt__btn--primary';
      yes.textContent = String(opts.ok || 'Continue');
      row.appendChild(no); row.appendChild(yes);
      box.appendChild(row);
      wrap.appendChild(box);

      var curEmail = '', curNick = '', occOpen = false;

      function read() {
        curEmail = String(emailInp.value || '').trim();
        curNick = String(nameInp.value || '').trim();
        return { email: curEmail, nick: curNick };
      }
      function showErr(msg, inp) {
        errEl.style.display = 'block';
        errEl.textContent = msg;
        if (inp) { try { inp.focus(); } catch (e) {} }
      }
      function showOcc() {
        occOpen = true;
        emailInp.style.display = 'none';
        nameInp.style.display = 'none';
        errEl.style.display = 'none';
        yes.style.display = 'none';
        no.textContent = 'Close';
        occ.style.display = 'block';
      }
      var OCC_MSG = {
        not_taken: 'This email is not in use yet \u2014 just continue normally.',
        mail_failed: 'We could not send the email right now. Please try again, or contact service@highdeep.net.',
        too_many_codes: 'Too many codes were sent. Please wait a few minutes and try again.',
        expired: 'That code has expired. Tap \u201CVerify this email\u201D to get a new one.',
        bad_code: 'That code is not correct. Check the email and try again.',
        too_many_attempts: 'Too many attempts. Please try again later, or contact service@highdeep.net.',
        no_code: 'No code was requested yet. Tap \u201CVerify this email\u201D first.',
        banned: 'This email cannot be used right now. Please contact service@highdeep.net.'
      };
      function occSay(msg, isErr) {
        occMsg.style.display = msg ? 'block' : 'none';
        occMsg.style.color = isErr ? '#DC2626' : '#6B7280';
        occMsg.textContent = msg || '';
      }
      function whoami(email, nick) {
        return ft(BRIDGE + '/designs/whoami?email=' + encodeURIComponent(email) +
          (nick ? ('&nickname=' + encodeURIComponent(nick)) : ''), { cache: 'no-store' }, 10000)
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      }
      function submit() {
        if (occOpen) { return; }
        var r = read();
        if (!r.email) { showErr('Enter your email.', emailInp); return; }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(r.email)) { showErr('That email does not look right.', emailInp); return; }
        if (!r.nick) { showErr('Enter your name / nickname.', nameInp); return; }
        yes.disabled = true;
        whoami(r.email, r.nick).then(function (res) {
          yes.disabled = false;
          if (res && res.valid) { close({ email: r.email, nick: r.nick, status: 'ok' }, resolve); return; }
          var reason = (res && res.reason) || '';
          if (reason === 'no_account') { close({ email: r.email, nick: r.nick, status: 'new' }, resolve); return; }
          if (reason === 'nickname_mismatch') { showOcc(); return; }
          showErr('Could not verify. Please try again.', null);
        });
      }

      occVerify.addEventListener('click', function () {
        occVerify.disabled = true; occVerify.textContent = 'Sending\u2026';
        occSay('');
        ft(BRIDGE + '/designs/verify/send', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: curEmail, nickname: curNick })
        }, 12000)
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (!d || !d.ok) { throw new Error((d && d.error) || 'send_failed'); }
            occCode.style.display = 'flex';
            occSay('Code sent to ' + curEmail + '. It expires in 10 minutes.');
            occCodeInp.value = '';
            try { occCodeInp.focus(); } catch (e) {}
          })
          .catch(function (e) {
            var k = String((e && e.message) || '');
            occSay(OCC_MSG[k] || ('Could not send the code (' + k + '). Please try again, or contact service@highdeep.net.'), true);
          })
          .then(function () { occVerify.disabled = false; occVerify.textContent = 'Verify this email'; });
      });
      function occConfirm() {
        var code = String(occCodeInp.value || '').replace(/\D/g, '').slice(0, 6);
        if (code.length !== 6) { occSay('Enter the 6-digit code from the email.', true); return; }
        occCodeOk.disabled = true; occCodeOk.textContent = 'Checking\u2026';
        occSay('');
        ft(BRIDGE + '/designs/verify/confirm', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: curEmail, nickname: curNick, code: code })
        }, 12000)
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (!d || !d.ok) { throw new Error((d && d.error) || 'bad_code'); }
            close({ email: curEmail, nick: curNick, status: 'ok' }, resolve);
          })
          .catch(function (e) {
            var k = String((e && e.message) || '');
            occSay(OCC_MSG[k] || ('That did not work (' + k + '). Please try again.'), true);
          })
          .then(function () { occCodeOk.disabled = false; occCodeOk.textContent = 'Confirm'; });
      }
      occCodeOk.addEventListener('click', occConfirm);
      occCodeInp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); occConfirm(); } });

      var key = function (e) {
        if (e.key === 'Escape') { e.preventDefault(); close(null, resolve); }
        else if (e.key === 'Enter') { e.preventDefault(); submit(); }
      };
      no.addEventListener('click', function () { close(null, resolve); });
      yes.addEventListener('click', submit);
      wrap.addEventListener('mousedown', function (e) { if (e.target === wrap) { close(null, resolve); } });
      document.addEventListener('keydown', key, true);

      cur = { wrap: wrap, key: key, resolve: resolve };
      document.body.appendChild(wrap);
      setTimeout(function () { try { emailInp.focus(); } catch (e) {} }, 30);
    });
  };
})();

/* ---- 图片载入淡入（唯一实现）----------------------------------------------------
   解决什么：列表页的图都是 loading="lazy"，滚到时「啪」一下弹出来 —— 滚动时最显眼的廉价感。
   三条取舍（为什么是这么挑的，改之前先读）：
     ① 只给 **`loading="lazy"` 且此刻尚未加载完成** 的图加隐藏类。懒加载图在视口外起步，
        套 opacity:0 不可能造成闪烁（还没到能看见的时候）。
     ② **eager / fetchpriority=high 一律不动** —— 那是 LCP 元素，淡入会推迟首屏绘制。
     ③ 已经 `complete` 的图直接跳过 —— 本来就看得见，再淡入等于闪一下。
   失败兜底：`error` 也补 is-loaded。否则图裂/被拦时会**永远 opacity:0**（比不淡入更糟）。
   🔴 画板 / 设计台 / 灯箱 / 站点背景层内的图一律排除（画板已裁决「不动」）。
   🔴 隐藏态挂在根类 .pf-motion-ready 之下（该类只由 pf-motion.js 添加）
      ⇒ 无 JS / JS 报错 / 老浏览器 ⇒ 不加类 ⇒ 图片本就可见，**不可能白屏**；
      `?pfm=off` 时 pf-motion.js 直接 return（不加根类）⇒ 本动效自动等同旧版。 */
window.HD.imgFade = (function () {
  var SKIP = '.pfm-modal, .pfm-board, #hdcoWrap, .pm-lightbox, .hd-zoom, .site-bg';
  var CLS = 'pf-imgfade';
  var DONE = 'is-loaded';

  function mark(img) {
    if (!img.classList.contains(DONE)) { img.classList.add(DONE); }
  }
  function consider(img) {
    if (!img || img.tagName !== 'IMG') { return; }
    if (img.getAttribute('loading') !== 'lazy') { return; }   /* 只挑懒加载图 */
    if (img.classList.contains(CLS)) {
      /* 二次经过（元素被重插 / 重扫）：若其实已经加载完，立刻放行，避免永久隐形 */
      if (img.classList.contains(DONE) || img.complete) { mark(img); }
      return;
    }
    if (img.closest(SKIP)) { return; }                        /* 画板/设计台/灯箱 排除 */
    if (img.complete) { return; }                             /* 已经看得见 ⇒ 不动它 */
    img.classList.add(CLS);
    /* 直接挂 load/error（不用 document 捕获）：元素即使被挪出/重插 DOM 也照样能收到，
       比全局捕获更可靠，而且只有这十几张图有监听、成本可忽略。 */
    img.addEventListener('load', function () { mark(img); }, { once: true });
    img.addEventListener('error', function () { mark(img); }, { once: true });
  }
  function scan(scope) {
    var host = (scope && scope.querySelectorAll) ? scope : document;
    if (host.tagName === 'IMG') { consider(host); }
    var list = host.querySelectorAll ? host.querySelectorAll('img[loading="lazy"]') : [];
    for (var i = 0; i < list.length; i++) { consider(list[i]); }
  }
  /* 动态插入的图（innerHTML 拼串）靠 MutationObserver 兜：
     它的回调是**微任务**，先于该图 load 事件（任务）执行 ⇒ 不会漏。
     ⚠️ 刻意**不用** IntersectionObserver：懒加载图本来就在视口外，IO 要等它进视口才触发，
        那一刻浏览器已经发起加载了，再套淡入就晚了（会闪）。 */
  var started = false;
  function watch() {
    if (started) { return; }
    started = true;
    scan(document);                                            /* defer 加载时 DOM 已解析 ⇒ 补首屏扫描 */
    if (!window.MutationObserver) { return; }
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j] && added[j].nodeType === 1) { scan(added[j]); }
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.documentElement) { watch(); }
  else { document.addEventListener('DOMContentLoaded', watch); }

  return { scan: scan };
})();

/* ---- Catalog prefetch & device cache (site-wide silent prefetch) ----
 * Any page opening schedules a silent idle-time fetch of the full catalog
 * (/catalog/categories — categories + all products) into localStorage, so the
 * product page renders instantly from the device cache instead of waiting on
 * the network. Refreshed once per session; failures are silent.
 * v2: cache key bumped to invalidate any pre-v2 (schema-unknown) payloads. */
window.HD.catalogCache = (function () {
  var KEY = 'hd_catalog_v2';
  var SCHEMA = 2; // bump when the cached JSON shape changes
  var TTL = 24 * 3600 * 1000; // freshness window
  function get() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || !o.data || !o.fetchedAt || o.schema !== SCHEMA) return null;
      return o;
    } catch (e) { return null; }
  }
  function set(data) {
    try {
      localStorage.setItem(KEY, JSON.stringify({ schema: SCHEMA, data: data, fetchedAt: Date.now() }));
      return true;
    } catch (e) { return false; }
  }
  function isFresh(o) {
    return !!(o && o.fetchedAt && (Date.now() - o.fetchedAt < TTL));
  }
  return { get: get, set: set, isFresh: isFresh, KEY: KEY };
})();

window.HD.prefetchCatalog = (function () {
  var started = false;
  var BRIDGE = 'https://bridge.highdeep.net';
  var MIN_INTERVAL = 10 * 60 * 1000; // SWR: refresh at most every 10 minutes
  function lastFetchedAt() {
    try {
      var c = HD.catalogCache.get();
      return (c && c.fetchedAt) || 0;
    } catch (e) { return 0; }
  }
  return function () {
    if (started) return;
    started = true;
    var run = function () {
      // 2026-09-04: 目标页短路——catalog 页自身 cache-first 拉取（读 hd_catalog_v2，未命中才拉），
      // 预热若再拉会与页面 init 双份请求（首访无缓存时）。其它页面照常跨页预热。
      if (location.pathname.indexOf('product-catalog') >= 0) return;
      // SWR (stale-while-revalidate): skip if we refreshed within 10 minutes,
      // otherwise silently fetch the catalog in the background. This keeps the
      // device cache fresher than once-per-session without hammering the bridge.
      var last = lastFetchedAt();
      if (last && (Date.now() - last < MIN_INTERVAL)) return;
      HD.ft(BRIDGE + '/catalog/categories', {}, 15000)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.success && d.categories) {
            HD.catalogCache.set(d.categories);
            console.log('[prefetch] catalog cached:', Object.keys(d.categories).length, 'categories');
          }
        })
        .catch(function (e) { console.warn('[prefetch] catalog prefetch failed:', e && e.message); });
    };
    // Idle-scheduled so it never competes with first-paint resources.
    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(run, { timeout: 5000 });
    } else {
      setTimeout(run, 3000);
    }
    // SWR: also re-check periodically while the tab stays open.
    setInterval(run, MIN_INTERVAL);
  };
})();

// ---- 2026-08-30: Drop 页数据预取（与 this-week-drop.liquid 共用缓存 key/schema/TTL）----
// 从任意页面进入 Drop 前，静默预取 works + heat 写入 localStorage →
// Drop 页缓存命中即可秒开（不再等 3 个网络请求）。
window.HD.prefetchDrop = (function () {
  var started = false;
  var BRIDGE = 'https://bridge.highdeep.net';
  var MIN_INTERVAL = 5 * 60 * 1000; // works 缓存 10min → 预取间隔 5min 即可
  function cached(key) {
    try {
      var o = JSON.parse(localStorage.getItem(key) || 'null');
      return !!(o && o.fetchedAt && (Date.now() - o.fetchedAt < MIN_INTERVAL));
    } catch (e) { return false; }
  }
  function set(key, schema, data) {
    try { localStorage.setItem(key, JSON.stringify({ schema: schema, data: data, fetchedAt: Date.now() })); } catch (e) {}
  }
  return function () {
    if (started) return;
    started = true;
    var run = function () {
      // 2026-09-04: 目标页短路——Drop 页自身 init 已拉全三接口，避免与预热双份请求
      if (location.pathname.indexOf('this-weeks-drop') >= 0) return;
      // works（10min 缓存）— 未缓存/过期则预取
      if (!cached('hd_works_v1')) {
        HD.ft(BRIDGE + '/creator/works', {}, 15000)
          .then(function (r) { return r.json(); })
          .then(function (d) { if (d && d.success && d.works) set('hd_works_v1', 2, d.works); }) // 2026-09-08: schema 1→2，与 this-week-drop 读取一致（原 1 导致 DROP 页缓存永不命中）
          .catch(function (e) { console.warn('[prefetch] works failed:', e && e.message); });
      }
      // heat（60s 缓存，变化快 — 仅当 60s 内未取才预取）
      if (!cached('hd_heat_v1')) {
        HD.ft(BRIDGE + '/heat/stats', {}, 10000)
          .then(function (r) { return r.json(); })
          .then(function (d) { if (d && d.success && d.works) set('hd_heat_v1', 1, d.works); })
          .catch(function () {});
      }
    };
    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(run, { timeout: 4000 });
    } else {
      setTimeout(run, 2500);
    }
    setInterval(run, MIN_INTERVAL);
  };
})();

// ---- 2026-09-08: 全站图片静默预载（catalog 产品图 + DROP 作品图，主页停留即备好）----
// 用户需求：在任意页面（尤其主页）停留后，进入 catalog / DROP / design-lab 时
// 图片已从浏览器缓存命中 → 秒开。数据层已有 prefetchCatalog/prefetchDrop/hoverPrefetch，
// 缺的是【图片】主动下载。此函数：
//  1) 读 hd_catalog_v2（或现拉 /catalog/categories）→ 每产品 p.image 预载
//     （与 catalog 页 img(p.image,420/900) 同 URL → 命中缓存）
//  2) 读 hd_works_v1（或现拉 /creator/works）→ 每作品 mockup_url/design_url 预载
//     （与 Drop 页 imgUrl(...,&w=设备宽) 对齐）
//  3) 每产品预热 hd_prod_v2_ 数据（design-lab 首次进详情秒开）
//  护栏：Save-Data/2G 跳过；会话级每 URL 一次；idle 分片 + 并发上限；全部静默失败。
//  单色主图 1 张/产品（Q2 定案），图源 = catalog p.image（官方产品首图）。
window.HD.prefetchImages = (function () {
  var started = false;
  var BRIDGE = 'https://bridge.highdeep.net';
  var doneUrls = {};      // 会话级：每个最终 URL 只试一次
  var triedPid = {};      // 会话级：每个 pid 数据预热一次
  var CONCURRENCY = 4;    // 同时下载的图上限（不突发，移动端友好）
  var GAP = 250;          // 批次间隔
  var queue = [];         // 待下载 URL 队列
  var active = 0;
  var timer = null;
  var prodTplQueue = [];  // 待数据预热 pid
  var prodTimer = null;
  var PROD_GAP = 300;
  function saveData() {
    try { var n = navigator.connection; if (n && (n.saveData === true || /2g|slow-2g/.test(n.effectiveType || ''))) return true; } catch (e) {}
    return false;
  }
  function proxy(u, w) {
    if (!u) return '';
    if (u.indexOf('//bridge.highdeep.net/') !== -1) return u; // 已代理/本域直用
    return BRIDGE + '/image-proxy?url=' + encodeURIComponent(u) + (w ? '&w=' + w : '');
  }
  // DROP 卡同款宽度（与 this-week-drop.liquid imgWidth() 一致）
  function dropWidth() {
    var w = window.innerWidth || 900;
    if (w <= 768) return 240;
    if (w <= 1280) return 560;
    return 800;
  }
  function enq(u) {
    if (!u || doneUrls[u]) return;
    doneUrls[u] = 1;
    queue.push(u);
    schedule();
  }
  function pump() {
    timer = null;
    while (active < CONCURRENCY && queue.length) {
      var u = queue.shift();
      if (!u) continue;
      active++;
      var im = new Image();
      im.decoding = 'async';
      im.onload = im.onerror = function () { active--; schedule(); }; // 成败都续跑
      im.src = u;
    }
  }
  function schedule() {
    if (active >= CONCURRENCY) return;
    if (timer || !queue.length) return;
    timer = setTimeout(pump, GAP);
  }
  function collectFromCatalog(catData) {
    // categories -> subcategories -> products[{id,image}]
    // 另按 catalog 页 renderTop 规则取每分类 firstImg（含 women 硬编码主图）→ 分类卡同 URL
    var list = [];
    var WOMEN_HARDCODE = 'https://files.cdn.printful.com/o/upload/product-catalog-img/b2/b22dcc75b47d6ef0ae63e2f5be4d0565_l';
    try {
      if (catData && typeof catData === 'object') {
        for (var k in catData) {
          var cat = catData[k];
          if (!cat || !cat.subcategories) continue;
          // 分类卡 firstImg（对齐 product-catalog-v2 renderTop）
          var firstImg = '';
          if (k === 'women') firstImg = WOMEN_HARDCODE;
          if (!firstImg) {
            for (var sk0 in cat.subcategories) {
              var pp0 = cat.subcategories[sk0].products || [];
              for (var i0 = 0; i0 < pp0.length; i0++) { if (pp0[i0].image) { firstImg = pp0[i0].image; break; } }
              if (firstImg) break;
            }
          }
          if (firstImg) list.push({ pid: '', image: firstImg, isCatCard: true });
          for (var sk in cat.subcategories) {
            var prods = cat.subcategories[sk].products || [];
            for (var i = 0; i < prods.length; i++) {
              var p = prods[i];
              if (!p || !p.id) continue;
              list.push({ pid: p.id, image: p.image || '', isCatCard: false });
            }
          }
        }
      }
    } catch (e) {}
    return list;
  }
  function collectFromWorks(works) {
    var list = [];
    try {
      if (works && works.length) {
        for (var i = 0; i < works.length; i++) {
          var w = works[i];
          if (!w) continue;
          /* 2026-10-26：**去掉 design_url 兜底** —— 未上架作品没有 mockup_url 时，
             原逻辑会取 design_url（2100×2400 原始设计稿，实测单张 1.3MB）做「预热」，
             但这些作品在 Drop 页根本不显示 ⇒ 纯浪费流量（实测 Drop 页 4.41MB 里 1.3MB 来自此）。
             只用 mockup_url（成品小图 ~30KB）；无 mockup = 未上架 = 跳过预热。 */
          var u = (w && w.mockup_url) || '';
          if (u) list.push(u);
        }
      }
    } catch (e) {}
    return list;
  }
  function warmProductData(pid) {
    pid = String(pid || '');
    if (!pid || triedPid[pid]) return;
    triedPid[pid] = 1;
    // 复用 hover 预取器的数据预热（hd_prod_v2_ + 首色 flat-template）
    try { if (window.HD && HD.prefetchProduct) HD.prefetchProduct(pid); } catch (e) {}
  }
  function pumpProd() {
    prodTimer = null;
    if (!prodTplQueue.length) return;
    var pid = prodTplQueue.shift();
    warmProductData(pid);
    if (prodTplQueue.length) prodTimer = setTimeout(pumpProd, PROD_GAP);
  }
  function queueProds(pids) {
    if (!pids || !pids.length) return;
    for (var i = 0; i < pids.length; i++) {
      var pid = String(pids[i] || '');
      if (pid && !triedPid[pid]) prodTplQueue.push(pid);
    }
    if (!prodTimer && prodTplQueue.length) prodTimer = setTimeout(pumpProd, 200);
  }
  return function () {
    if (started) return;
    started = true;
    var run = function () {
      if (saveData()) { console.log('[prefetch-img] SaveData/2G — skip image prefetch'); return; }
      // 读缓存优先（跨页已写入）；无则现拉后落缓存
      var cats = null;
      try { var co = JSON.parse(localStorage.getItem('hd_catalog_v2') || 'null'); if (co && co.data) cats = co.data; } catch (e) {}
      var works = null;
      try { var wo = JSON.parse(localStorage.getItem('hd_works_v1') || 'null'); if (wo && wo.data) works = wo.data; } catch (e) {}
      var proceed = function () {
        var prods = collectFromCatalog(cats);
        var pids = [];
        for (var i = 0; i < prods.length; i++) {
          var it = prods[i];
          var im = it.image;
          if (!im) continue;
          if (it.isCatCard) {
            // 分类卡 = img(firstImg, 560) 同 URL（下采样后一致命中）
            if (im) enq(proxy(im, 560));
            continue;
          }
          pids.push(it.pid);
          // 列表(420) + 详情(900) 两档对齐 catalog 实际渲染
          var u420 = proxy(im, 420), u900 = proxy(im, 900);
          enq(u420); enq(u900);
        }
        var wl = collectFromWorks(works);
        var dw = dropWidth();
        for (var j = 0; j < wl.length; j++) enq(proxy(wl[j], dw));
        // 产品数据预热（design-lab/详情秒开）
        queueProds(pids);
        console.log('[prefetch-img] queued images:', queue.length, 'products:', pids.length, 'works:', wl.length);
      };
      var needCatsFetch = !cats, needWorksFetch = !works;
      if (needCatsFetch || needWorksFetch) {
        var p1 = needCatsFetch
          ? HD.ft(BRIDGE + '/catalog/categories', {}, 15000).then(function (r) { return r.json(); }).then(function (d) { if (d && d.categories) { cats = d.categories; try { HD.catalogCache.set(d.categories); } catch (e) {} } }).catch(function () {})
          : Promise.resolve();
        var p2 = needWorksFetch
          ? HD.ft(BRIDGE + '/creator/works', {}, 15000).then(function (r) { return r.json(); }).then(function (d) { if (d && d.works) works = d.works; }).catch(function () {})
          : Promise.resolve();
        Promise.all([p1, p2]).then(proceed);
      } else {
        proceed();
      }
    };
    // idle 启动（不抢首屏资源）
    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(run, { timeout: 8000 });
    } else {
      setTimeout(run, 3500);
    }
  };
})();

// ---- 2026-09-08: 监听导航 — 点进 catalog/DROP/design-lab 前（hover 停留）立即加速剩余图 ----
// prefetchImages 是"站内全量"慢预热；这里做"点击前"补刀：任何指向 catalog/drop/design-lab
// 的链接 hover>200ms 就先把该页 top 图拉了（如 catalog 详情打开的产品图 900）。
window.HD.prefetchNavImg = (function () {
  var done = {};
  var timer = null;
  function grab(href) {
    try {
      var u = new URL(href, location.origin);
      var params = u.searchParams;
      if (!params) return;
      // catalog 详情 / design-lab 都带 product_id → 直接预载该产品 900 主图 + 数据
      var pid = params.get('product_id') || params.get('pid') || '';
      if (!pid) return;
      var key = pid;
      if (done[key]) return;
      done[key] = 1;
      // 数据（可能 catalog 缓存未含产品）
      try { if (window.HD && HD.prefetchProduct) HD.prefetchProduct(pid); } catch (e) {}
      // 主图 900：从 catalog 缓存反查 product.image
      try {
        var co = JSON.parse(localStorage.getItem('hd_catalog_v2') || 'null');
        if (co && co.data) {
          for (var k in co.data) { var cat = co.data[k]; if (!cat || !cat.subcategories) continue;
            for (var sk in cat.subcategories) { var prods = cat.subcategories[sk].products || [];
              for (var i = 0; i < prods.length; i++) { if (String(prods[i].id) === String(pid) && prods[i].image) {
                var im = new Image(); im.decoding = 'async';
                var url = prods[i].image.indexOf('//bridge.highdeep.net/') !== -1 ? prods[i].image : ('https://bridge.highdeep.net/image-proxy?url=' + encodeURIComponent(prods[i].image) + '&w=900');
                im.src = url; return;
              } } } }
        }
      } catch (e) {}
    } catch (e) {}
  }
  return function () {
    document.addEventListener('mouseover', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      /* 2026-10-11 退役 work-detail 预览页 ⇒ 预热白名单同步收窄（只剩 catalog / design-lab）。 */
      if (href.indexOf('/pages/product-catalog') === -1 && href.indexOf('/pages/design-lab') === -1) return;
      if (timer) clearTimeout(timer);
      var h = href;
      timer = setTimeout(function () { grab(h); }, 180);
    }, true);
  };
})();

// Auto-run on every page, slightly delayed so it doesn't disturb initial render.
// 2026-08-30: 900ms → 300ms — 预取提前，移动端尽早开始拉数据
// 2026-09-08: +prefetchImages（全站图静默预载）+prefetchNavImg（点前补刀）——懒加载层
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () { setTimeout(function(){ window.HD.prefetchCatalog(); window.HD.prefetchDrop(); window.HD.prefetchImages && window.HD.prefetchImages(); }, 300); });
} else {
  setTimeout(function(){ window.HD.prefetchCatalog(); window.HD.prefetchDrop(); window.HD.prefetchImages && window.HD.prefetchImages(); }, 300);
}
// 导航 hover 补刀（页面 JS 就绪后启动）
setTimeout(function(){ try { window.HD.prefetchNavImg && window.HD.prefetchNavImg(); } catch (e) {} }, 2500);

/* ---- Hover prefetch (navigation prediction) ----
 * When the user hovers a nav/product link for >200ms, silently prefetch that
 * page's HTML so the click feels instant. Only prefetches each href once per
 * session, and skips external links / anchors. Cheap: one <link rel=prefetch>
 * per target, browser handles caching. */
window.HD.hoverPrefetch = (function () {
  var done = {};
  var timer = null;
  function prefetch(url) {
    if (done[url]) return;
    done[url] = 1;
    try { sessionStorage.setItem('hd_hoverpre_' + url, '1'); } catch (e) {}
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = url;
    document.head.appendChild(l);
  }
  return function () {
    document.addEventListener('mouseover', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      // Only internal same-origin pages worth prefetching
      if (!href || href.charAt(0) === '#' || href.indexOf('javascript:') === 0) return;
      if (/^https?:\/\//i.test(href) && href.indexOf(location.origin) !== 0) return;
      if (/\.(png|jpe?g|gif|webp|svg|css|js|woff2?|pdf)(\?|$)/i.test(href)) return;
      if (done[href]) return;
      // Debounce: restart 200ms timer on each hover move so we only prefetch
      // when the user actually pauses on the link.
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () { prefetch(href); }, 200);
    }, true);
  };
})();
// Start after a short delay so it never competes with initial page work.
setTimeout(window.HD.hoverPrefetch, 1500);

// ---------- 访问栈自记（2026-09-16）----------
// 为什么需要：部分浏览器 / WebView（鸿蒙 ArkWeb、应用内浏览器）不给页面可用的 history
//（history.length 恒为 1 → window.history.back() 无效），且页面 location.reload() 之后
// document.referrer 会变成当前页自己（购物车清空最后一行即走 reload —— 实测）。
// 为什么是「栈」而不是「记一条来源」：只记一条**只能后退一层**，退到第二层时那条记录
// 会指向「刚离开的页面」⇒ 购物车 ⇄ 产品详情 来回弹（用户实测）。
// 栈 = 本站访问过的路径数组；每次「返回」弹掉当前页再取新栈顶 ⇒ 线性、可终止。
window.HD._histRead = function () {
  try { return JSON.parse(sessionStorage.getItem('hd_hist') || '[]') || []; } catch (e) { return []; }
};
window.HD._histWrite = function (st) {
  try { sessionStorage.setItem('hd_hist', JSON.stringify(st.slice(-40))); } catch (e) { /* 隐私模式：静默降级 */ }
};
window.HD.trackPage = function () {
  try {
    var cur = location.pathname + location.search;
    var st = window.HD._histRead();
    if (!st.length || st[st.length - 1] !== cur) { st.push(cur); window.HD._histWrite(st); }
  } catch (e) { /* 隐私模式 / 禁用 storage：静默降级，不影响其它分支 */ }
};
// 取「上一页」并把当前页弹掉（每次调用只退一层）
window.HD.backTarget = function () {
  try {
    var cur = location.pathname + location.search;
    var st = window.HD._histRead();
    if (st.length && st[st.length - 1] === cur) st.pop();
    window.HD._histWrite(st);
    var t = st.length ? st[st.length - 1] : '';
    if (!t || t === cur) return '';
    return (t.charAt(0) === '/' && t.charAt(1) !== '/') ? t : '';
  } catch (e) { return ''; }
};
window.HD.trackPage();

// ---------- 公共返回函数（2026-08-28，统一给产品页/各页面复用） ----------
// 逻辑与 design-canvas 的 window.goBack 对齐。
// ★ 2026-09-16 顺序修正：**history.back() 提到最前** —— 它是唯一能命中 bfcache（往返缓存）的路径。
//   原顺序把 return_url / referrer 放在前面，走的是 window.location.href 赋值 = 发起一次新导航，
//   浏览器必须重新下载 HTML、重新解析、重新执行 JS（所以「返回」看起来像重新加载）。
//   实测同一个「← Back」按钮：
//     改前  navigation.type=navigate       transferSize=300  domInteractive 418ms   🔴 重新加载
//     改后  navigation.type=back_forward   transferSize=0    domInteractive  40ms   ✅ bfcache 秒回
//   安全前提：从本站其它页进来（referrer 同源）且 history 有上一页；
//   若带 return_url 且它的路径与 referrer 不同（= 明确指定了另一个返回目标），仍走完整导航，语义不变。
// ★ 2026-09-16 乐观试退（方案 A）—— 不再相信 window.history.length：
//   部分浏览器 / WebView（鸿蒙 ArkWeb、应用内浏览器）该值恒为 1 ⇒ 下面所有分支都会跳过
//   history.back()，全站返回键一律走 location.href 整页导航（实测 469ms~1.7s；而命中 bfcache 只需 28~41ms）。
//   故改为「先试后退，320ms 内没开始导航才回退到兜底导航」。
window.HD._tryBack = function (onFail) {
  // ① history.length 可信（>1）⇒ 直接交给浏览器，**不设计时器**。
  //    原因：计时器一旦在「慢加载」时误触发，会紧跟着再发一次导航（双导航），
  //    实测会让本来正常的返回变成整页重下 —— 得不偿失。这条路径与改动前的稳定行为完全一致。
  if (window.history.length > 1) {
    try { window.history.back(); return; } catch (e) { onFail(); return; }
  }

  // ② history.length 不可信（部分 WebView / 应用内浏览器恒为 1）⇒ 乐观试退：
  //    直接试 history.back()，若 ~400ms 内没开始导航（pagehide / popstate 都没来）才走兜底。
  //    ⚠️ pagehide 只在「新页面提交时」触发，非 bfcache 的后退要几百 ms，所以窗口不能太短。
  var armed = true;
  function stop() {
    armed = false;
    window.removeEventListener('pagehide', stop, true);
    window.removeEventListener('popstate', stop, true);
  }
  window.addEventListener('pagehide', stop, true);
  window.addEventListener('popstate', stop, true);
  try { window.history.back(); } catch (e) { stop(); onFail(); return; }
  setTimeout(function () { if (armed) { stop(); onFail(); } }, 400);
};

// ---------- 公共返回函数（2026-08-28，统一给产品页/各页面复用） ----------
// 顺序（**别乱动**）：
//   ① return_url 明确指向「不是本次来源」的页面 → 按它导航（语义不变；设计台等显式目标）
//   ② 上一页确定在站内（referrer 同源 或 自记访问栈有上一页）→ 乐观试退 history.back()（命中 bfcache = 秒回）
//   ③ 兜底链：return_url → 访问栈上一页 → 首页
//   ⚠️ 不用 referrer 当返回依据：用 push 实现的返回会让目标页 referrer 自指 ⇒ 必然乒乓（实测）。
//   ⚠️ 不用 history.length 当门槛：该值在部分设备不可信（恒为 1），会把 history.back() 整条路封死。
window.HD.goBack = function (fallback) {
  var params = new URLSearchParams(location.search);
  var returnUrl = params.get('return_url');
  var cur = location.pathname + location.search;
  var sameOriginRef = document.referrer && document.referrer !== window.location.href
    && document.referrer.indexOf(location.origin) === 0;

  // 安全白名单：只允许站内相对 /pages/ 路径（防 open-redirect / javascript:）
  function safeReturn() {
    if (!returnUrl || !returnUrl.trim()) return '';
    var u = returnUrl.trim();
    if (u.charAt(0) === '/' && u.charAt(1) !== '/' && /^\/pages\//.test(u)) return u;
    console.warn('[goBack] blocked unsafe return_url:', u);
    return '';
  }
  var u = safeReturn();

  // 「上一页确定在站内」才敢试 history.back()：referrer 同源，或自记访问栈里确实有上一页
  var stk = window.HD._histRead ? window.HD._histRead() : [];
  var stackPrev = (stk.length > 1 && stk[stk.length - 1] === cur) ? stk[stk.length - 2] : '';
  var trustHistory = !!sameOriginRef || !!stackPrev;

  // 先弹掉访问栈当前层（与「用户退了一层」同步；无论最终走哪条路都一致）
  var prevPath = window.HD.backTarget ? window.HD.backTarget() : '';

  function manual() {
    if (u) { window.location.href = u; return; }
    if (prevPath) { window.location.href = prevPath; return; }
    window.location.href = (typeof fallback === 'string' && fallback) ? fallback : '/';
  }

  // ① return_url 明确指向另一个页面 → 直接按它导航
  if (u && sameOriginRef) {
    var sameAsReturn = true;
    try {
      sameAsReturn = (new URL(u, location.origin).pathname
        === new URL(document.referrer, location.origin).pathname);
    } catch (e) { sameAsReturn = false; }
    if (!sameAsReturn) { window.location.href = u; return; }
  }

  // ② 乐观试退（命中 bfcache = 秒回）；失败则走兜底链
  if (trustHistory) { window.HD._tryBack(manual); return; }

  // ③ 没有任何「上一页在站内」的证据 → 直接兜底，绝不冒险退到站外
  manual();
};

// ---------- HD.apiMemo（2026-09-04 性能：bridge GET 数据缓存池） ----------
// 解决"每次整页跳转都把 catalog/product 等重新拉一遍"：内存+sessionStorage 双写
// （sessionStorage 跨整页导航存活）+ in-flight 并发去重 + TTL 毫秒。
// 用法：HD.apiMemo(url, ttlMs, {bypass,noStore}) → Promise<json>
window.HD.apiMemo = (function () {
  var KEY = 'hd_apimemo_v1';
  var mem = {};          // key -> {exp, v}
  var inflight = {};     // key -> Promise
  var SS = null;
  try { SS = window.sessionStorage; } catch (e) {}
  function loadSS() {
    if (!SS) return {};
    try { return JSON.parse(SS.getItem(KEY) || '{}'); } catch (e) { return {}; }
  }
  function saveSS(o) {
    if (!SS) return;
    try { SS.setItem(KEY, JSON.stringify(o)); } catch (e) {} // 满/隐私模式静默
  }
  // 剥掉缓存破坏参数（v/t/_/cb/ts/rnd）后做 key
  function normKey(url) {
    var qi = url.indexOf('?');
    var path = qi < 0 ? url : url.slice(0, qi);
    var q = qi < 0 ? '' : url.slice(qi + 1);
    q = q.split('&').filter(function (p) {
      return p && !/^(v|t|_|cb|ts|rnd)=/i.test(p);
    }).sort().join('&');
    return path + (q ? '?' + q : '');
  }
  return function (url, ttlMs, opts) {
    opts = opts || {};
    ttlMs = ttlMs || 60000;
    var key = normKey(url);
    if (!opts.bypass) {
      var m = mem[key];
      if (m && m.exp > Date.now()) return Promise.resolve(m.v);
      if (!m) {
        var s = loadSS()[key];
        if (s && s.exp > Date.now()) { mem[key] = s; return Promise.resolve(s.v); }
      }
    }
    if (!opts.bypass && inflight[key]) return inflight[key];
    var p = HD.ft(url, { headers: { 'Accept': 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then(function (j) {
      if (!opts.noStore) {
        var rec = { exp: Date.now() + ttlMs, v: j };
        mem[key] = rec;
        var o = loadSS(); o[key] = rec; saveSS(o); // 双写：跨整页导航可用
      }
      return j;
    });
    var tracked = p.then(function (v) { delete inflight[key]; return v; },
                         function (e) { delete inflight[key]; throw e; });
    inflight[key] = tracked;
    return tracked;
  };
})();
window.HD.apiMemoClear = function () {
  mem = {};
  try { if (SS) SS.removeItem('hd_apimemo_v1'); } catch (e) {}
};

// ---------- 产品级 hover 预取（2026-09-04）----------
// 悬停在目录页产品上时，后台预取「产品详情 + 角度模板 + 打印文件」，写入与 design-canvas
// 完全一致的 v2 缓存键（hd_prod_v2_<id> / hd_tpl_v2_<id>_，无颜色=默认首色）→ 点进设计台时
// loadProduct 直接命中缓存秒开。键/校验约定与 design-canvas 严格一致；失败静默不影响功能。
window.HD.prefetchProduct = (function () {
  var BRIDGE = 'https://bridge.highdeep.net';
  var PROD_KEY = function (pid) { return 'hd_prod_v2_' + pid; };
  var TPL_KEY = function (pid) { return 'hd_tpl_v2_' + pid + '_'; };
  var done = {}; // 会话内每 pid 只尝试一次（成功/失败都不重复刷接口）
  function hasProd(pid) {
    try {
      var raw = localStorage.getItem(PROD_KEY(pid)); if (!raw) return false;
      var o = JSON.parse(raw);
      if (!o || !o.product || !o.fetchedAt || (Date.now() - o.fetchedAt > 24 * 3600 * 1000)) return false;
      var p = o.product;
      return !!(p && p.placements && p.variants && p.variants.length);
    } catch (e) { return false; }
  }
  function hasTpl(pid) {
    try {
      var raw = localStorage.getItem(TPL_KEY(pid)); if (!raw) return false;
      var o = JSON.parse(raw);
      return !!(o && o.ts && (Date.now() - o.ts < 6 * 3600 * 1000) && o.flat && o.pf);
    } catch (e) { return false; }
  }
  return function (pid) {
    pid = String(pid || '');
    if (!pid || !window.HD || !HD.ft || done[pid]) return;
    done[pid] = 1;
    var needProd = !hasProd(pid), needTpl = !hasTpl(pid);
    if (!needProd && !needTpl) return;
    var chain = Promise.resolve();
    if (needProd) {
      chain = chain.then(function () {
        return HD.ft(BRIDGE + '/catalog/product/' + pid, {}, 12000).then(function (r) { return r.json(); });
      }).then(function (d) {
        if (d && d.product) {
          try { localStorage.setItem(PROD_KEY(pid), JSON.stringify({ product: d.product, fetchedAt: Date.now() })); } catch (e) {}
        }
      });
    }
    if (needTpl) {
      chain = chain.then(function () {
        return Promise.all([
          HD.ft(BRIDGE + '/catalog/product/' + pid + '/flat-template?color=', {}, 20000),
          HD.ft(BRIDGE + '/catalog/product/' + pid + '/printfiles', {}, 12000)
        ]).then(function (rs) { return Promise.all(rs.map(function (r) { return r.json(); })); });
      }).then(function (arr) {
        var tdata = arr[0] || {}, pfdata = arr[1] || {};
        if (tdata && typeof tdata === 'object') {
          try { localStorage.setItem(TPL_KEY(pid), JSON.stringify({ ts: Date.now(), flat: tdata, pf: pfdata })); } catch (e) {}
        }
      });
    }
    chain.catch(function (e) { console.warn('[prefetchProduct]', pid, e && e.message); });
  };
})();

// ---- 2026-09-05: Drop 在售作品集「产品详情层」全量静默预热 ----
// 移动端无 hover（作品卡 hover 预取只在桌面生效），点卡片前先把 product 数据备好，进页即显色码/价格。
// 此函数把 product_id（去重）idle 分片预取——只拉 /catalog/product，写 hd_prod_v2_
// （与 prefetchProduct / design-canvas / catalog 详情共享同键同校验）⇒ cache-first 命中秒开。
// 2026-10-11: work-detail 预览页退役后，消费方只剩 catalog / design-lab 两处（口径不变）。
// 护栏：省流量/2G 跳过；每 pid 会话级一次（成败均不重试）。
window.HD.prefetchWorksProducts = (function () {
  var BRIDGE = 'https://bridge.highdeep.net';
  var tried = {};   // 会话级：入队即标记（防重复入队/失败重刷）
  var queue = [];
  var timer = null;
  var GAP = 150;    // 2026-09-05 方案2: 400→150ms（bridge 已 HTTP/2 多路复用，密集小间隔无害）
  var first = true; // 本轮首次入队 → 首款立即发出（不等 GAP）
  function hasProd(pid) {
    try {
      var raw = localStorage.getItem('hd_prod_v2_' + pid); if (!raw) return false;
      var o = JSON.parse(raw);
      if (!o || !o.product || !o.fetchedAt || (Date.now() - o.fetchedAt > 24 * 3600 * 1000)) return false;
      var p = o.product;
      return !!(p && p.placements && p.variants && p.variants.length);
    } catch (e) { return false; }
  }
  function fetchOne(pid) {
    HD.ft(BRIDGE + '/catalog/product/' + pid, {}, 12000)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.product) {
          try { localStorage.setItem('hd_prod_v2_' + pid, JSON.stringify({ product: d.product, fetchedAt: Date.now() })); } catch (e) {}
        }
      })
      .catch(function (e) { console.warn('[prefetchWorksProducts]', pid, e && e.message); });
  }
  function pump() {
    timer = null;
    while (queue.length) {
      var pid = queue.shift();
      if (!pid) continue;
      fetchOne(pid); // 每次只发一款，剩余留给下一 GAP 切片（不突发）
      break;
    }
    if (!queue.length) { first = true; return; } // 队列清空 → 下次入队首款立即
    schedule();
  }
  function schedule() {
    if (timer || !queue.length) return;
    timer = setTimeout(pump, first ? 0 : GAP);
    first = false;
  }
  var pub = function (works) {
    if (!works || !works.length) return;
    try {
      var nav = navigator.connection;
      if (nav && (nav.saveData === true || /2g|slow-2g/.test(nav.effectiveType || ''))) return; // 省流量护栏
    } catch (e) {}
    var added = false;
    for (var i = 0; i < works.length; i++) {
      var pid = String((works[i] && works[i].product_id) || '');
      if (!pid || tried[pid] || hasProd(pid)) continue;
      tried[pid] = 1;
      queue.push(pid);
      added = true;
    }
    if (added) schedule();
  };
  // 2026-09-05 方案2: 单款立即补拉（Drop 卡 pointerdown 调用）——命中队列则摘除防双拉；
  // 与主队列共享 tried/hasProd 防重，写同一 hd_prod_v2_ 键（进 catalog / design-lab 秒显）
  pub.now = function (pid) {
    pid = String(pid || '');
    if (!pid || tried[pid] || hasProd(pid)) return;
    tried[pid] = 1;
    var i = queue.indexOf(pid);
    if (i >= 0) queue.splice(i, 1);
    fetchOne(pid);
  };
  return pub;
})();

// ---- 2026-09-09: design-lab 入口预热 — 进设计台前把目标产品"成品图"下进浏览器缓存 ----
// DROP/catalog 产品卡点击瞬间调用；color 空=默认首色（与 design-lab 无 color 入口一致）。
// 流程: flat-template(6h 缓存快) → prodPreview 各面 URL → new Image(&w=900) 预载 →
// 用户松手进 design-lab 时首面图已在 HTTP 缓存 → 秒开（DROP 同哲学：进页前图已就绪）
window.HD.prefetchProdImages = (function () {
  var BRIDGE = 'https://bridge.highdeep.net';
  var inflight = {}; // pid|color 会话级去重（成功后 60s 内不重复）
  var faceList = ['front', 'back', 'sleeve_left', 'sleeve_right'];
  return function (pid, color) {
    if (!pid) return;
    var key = String(pid) + '|' + String(color || '');
    if (inflight[key]) return;
    inflight[key] = 1;
    var url = BRIDGE + '/catalog/product/' + pid + '/flat-template';
    if (color) url += '?color=' + encodeURIComponent(color);
    HD.ft(url, {}, 12000)
      .then(function (r) { return r.json(); })
      .then(function (td) {
        var pp = (td && td.prodPreview) || {};
        faceList.forEach(function (f) {
          var u = pp[f] || (f === 'front' ? (pp.front_large || '') : '');
          if (!u) return;
          var im = new Image();
          im.decoding = 'async';
          im.src = u; // prodimg 原图（与 design-canvas 直贴/预载同 URL → HTTP 缓存命中秒开）
        });
        setTimeout(function () { delete inflight[key]; }, 60000);
      })
      .catch(function () { setTimeout(function () { delete inflight[key]; }, 15000); });
  };
})();
